import { useEffect } from 'react'

import MessageContentHead from 'view/op/messages/MessageContentHead'
import MessageContentBody from 'view/op/messages/MessageContentBody'

const MessageContent = ({
  refresher,
  selectedConversation
}) =>
{
  useEffect(() => {
    /* make sure things are updated */
  }, [refresher])

  if (!selectedConversation) {
    return (
      <section className="message-content empty"></section>
    )
  }

  const { name, phoneNumber } = selectedConversation
  return (
    <section className="message-content">
      <MessageContentHead name={ name || phoneNumber }/>
      <MessageContentBody name={ name || phoneNumber } conversation={selectedConversation} />
    </section>
  )
}

export default MessageContent
